function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
import styled from "styled-components";
import { ButtonPrimary } from "../../";
export const ButtonFacebook = ({
  children,
  ...props
}) => {
  return /*#__PURE__*/React.createElement(ButtonFacebookWrap, _extends({}, props, {
    iconLeft: /*#__PURE__*/React.createElement("svg", {
      width: "16px",
      height: "16px",
      viewBox: "0 0 32 32"
    }, /*#__PURE__*/React.createElement("g", {
      id: "Logos",
      stroke: "none",
      "stroke-width": "1",
      fill: "none",
      "fill-rule": "evenodd"
    }, /*#__PURE__*/React.createElement("g", {
      id: "Logo/Third-Party/Facebook/Facebook/Reversed",
      fill: "#FFFFFF"
    }, /*#__PURE__*/React.createElement("g", {
      id: "flogo-HexRBG-Wht-72"
    }, /*#__PURE__*/React.createElement("path", {
      d: "M30.2222222,0 L1.77777778,0 C0.795938223,0 0,0.795938223 0,1.77777778 L0,30.2222222 C0,31.2040618 0.795938223,32 1.77777778,32 L17.0933333,32 L17.0933333,19.6266667 L12.9377778,19.6266667 L12.9377778,14.7822222 L17.0933333,14.7822222 L17.0933333,11.2266667 C17.0933333,7.09333333 19.6177778,4.84444444 23.3155556,4.84444444 C24.5595781,4.84080886 25.8028833,4.90460615 27.04,5.03555556 L27.04,9.33333333 L24.48,9.33333333 C22.48,9.33333333 22.0933333,10.2844444 22.0933333,11.6844444 L22.0933333,14.7688889 L26.8888889,14.7688889 L26.2666667,19.6133333 L22.0933333,19.6133333 L22.0933333,32 L30.2222222,32 C31.2040618,32 32,31.2040618 32,30.2222222 L32,1.77777778 C32,0.795938223 31.2040618,0 30.2222222,0 Z",
      id: "Path"
    })))))
  }), children);
};
export const ButtonFacebookWrap = styled(ButtonPrimary)`
  background-color: ${props => props.theme.colors.facebook};
  color: #ffffff;

  &:hover,
  &:focus {
    background-color: ${props => props.theme.colors.facebook};
    box-shadow: 0 8px 8px 0 rgba(0, 0, 0, 0.24), 0 0 8px 0 rgba(0, 0, 0, 0.32);
  }
`;